import * as types from './types';

// Action Creators
export const setWindowSize = () => ({
  type: types.SET_WINDOW_SIZE,
});
